// extracted by mini-css-extract-plugin
export default {"container":"Acn0a","wrapper":"_3Voiw","title":"_1OCud","icon":"_2KXg0"};